import { Component, OnInit } from '@angular/core';
import { BaseDynamicViewComponent } from 'src/app/common/components/dynamic-view-v2/components/base-dynamic-form/base-dynamic-view.component';
import { DynamicCardType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicCardType';
import { DynamicViewType } from 'src/app/common/components/dynamic-view-v2/enums/DynamicViewType';
import BaseEntityDto from 'src/app/common/dtos/BaseEntityDto';
import { BaseViewFieldType } from 'src/app/common/components/dynamic-view-v2/enums/BaseViewFieldType';

@Component({
  selector: 'app-reward-track-template-view-v2',
  templateUrl: './reward-track-template-view-v2.component.html',
  styleUrls: ['./reward-track-template-view-v2.component.sass']
})
export class RewardTrackTemplateViewV2Component extends BaseDynamicViewComponent implements OnInit {
  rewardsTrackRecord: BaseEntityDto = new BaseEntityDto();

  constructor() {
    super();
  }

  ngOnInit() {
    this.fields = [
      {
        title: 'Rewards Track Template',
        fields: [
          {
            name: 'Name',
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Text],
            key: 'name',
            label: 'Name',
            columnWidth: 6
          },
          {
            name: 'Type',
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.DropdownWithLabels],
            clearField: true,
            key: 'type',
            label: 'Track Type',
            isRequired: true,
            options: {
              fieldName: 'type',
              values: [
                { name: 'Login Rewards - 7 days', value: 1 },
                { name: 'Login Rewards - Day 30', value: 2 },
                { name: 'Garden Pass - Free', value: 3 },
                { name: 'Garden Pass - Paid', value: 4 },
                { name: 'Friends Invited', value: 5 },
                { name: 'Endless Offer', value: 6 },
                { name: 'Co-Op', value: 7 },
                { name: 'Mini Games', value: 8 },
                { name: 'Seasonal Prizes', value: 9 },
                { name: 'Daily Activities', value: 10 },
                { name: 'Perk Daily Reward', value: 11 }
              ]
            },
            columnWidth: 6
          },
        ],
        type: DynamicCardType.Card
      },
      {
        title: 'Reward Track Configuration',
        fields: [
          {
            name: 'Rewards Tracks',
            inputType: DynamicViewType.RewardTrack,
            key: 'RewardTrack',
            label: 'Reward Tracks'
          }
        ],
        type: DynamicCardType.Card
      }
    ];

    this.title = 'Rewards Track Template';
    this.viewRoute = 'rewards-track-templates';
    this.isLoading = false;
  }
}
